module.exports = __webpack_public_path__ + "static/media/2.25b850b8.png";